/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinklisting2Inputs */

const en_droplinklisting2 = /** @type {(inputs: Droplinklisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_droplinklisting2 = /** @type {(inputs: Droplinklisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Droplinklisting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinklisting2 = /** @type {((inputs?: Droplinklisting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinklisting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinklisting2(inputs)
	return de_droplinklisting2(inputs)
});
export { droplinklisting2 as "dropLinkListing" }